export enum Path {
  AppRoot = "/app",
  DataEntry = "/app/data-entry",
  EmailVerify = "/email/verify",
  GoalCurrent = "/app/goals/current",
  GoalNext = "/app/goals/next",
  Goals = "/app/goals",
  Login = "/login",
  ProjInvite = "/invite",
  ProjScreen = "/app/projects",
  ProjSettings = "/app/project-settings",
  PwRequest = "/pw/request",
  PwReset = "/pw/reset",
  Root = "/",
  Signup = "/signup",
  SiteSettings = "/app/site-settings",
  Statistics = "/app/statistics",
  UserSettings = "/app/user-settings",
}
